import { render } from "./ReceivingHistoryModal.vue?vue&type=template&id=c4185cbc&scoped=true"
import script from "./ReceivingHistoryModal.vue?vue&type=script&lang=js"
export * from "./ReceivingHistoryModal.vue?vue&type=script&lang=js"

import "./ReceivingHistoryModal.vue?vue&type=style&index=0&id=c4185cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4185cbc"]])

export default __exports__